export const ASSIGNMENT_QUEUE = 'Assignment Queue';
export const NRBS_RECORD_NUMBER_LEN = 10;
